export const inlineSortBoolean = (a, b) => {
  return a === b ? 0 : a ? -1 : 1;
};